import {
    Alert,
    Box,
    Button,
    Paper,
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TextField,
    TablePagination
} from '@mui/material'
import { TableLoadingSpinner } from '../../../dashboard/shared-components/GraphLoadingSpinner'
import CustomSearchBar from './CustomSearchBar'

export default function EmissionFactorTable({
    formState,
    formError,
    isLoading,
    isPosting,
    searchQuery,
    currentPage,
    rowsPerPage,
    totalRows,
    handleChangePage,
    handleChangeRowsPerPage,
    handleChange,
    onSubmit,
    handleSearch }) {
    const emissionFactorColumns = [
        'App Activity',
        'Emission Source',
        'Default Factor',
        'Factor',
        'UOM',
        'Source',
    ]

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            {isLoading
                ? <TableLoadingSpinner tableTitle={'Emission Factor'} />
                : <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Box>
                        <CustomSearchBar searchQuery={searchQuery} handleSearch={handleSearch} />
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                        <TableContainer component={Paper}>
                            <Table size={'small'} aria-label='a dense table'>
                                <TableHead>
                                    <TableRow>
                                        {emissionFactorColumns.map((column, index) => (
                                            <TableCell
                                                sx={{ fontSize: 22, fontWeight: 'bold', py: 2 }}
                                                align='left'
                                                key={index}>{column}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        formState?.length > 0 && formState?.map((row, index) => (
                                            <TableRow
                                                key={index}
                                                sx={{
                                                    '&:last-child td, &:last-child th': { border: 0 }
                                                }}>
                                                <TableCell align='left'>{row.app_activity}</TableCell>
                                                <TableCell align='left'>{row.emission_source}</TableCell>
                                                <TableCell align='left'>{row.default_factor}</TableCell>
                                                <TableCell align='left'>
                                                    <TextField
                                                        name={'factor'}
                                                        sx={{
                                                            width: '100%', '& input::placeholder': {
                                                                fontStyle: 'italic'
                                                            }
                                                        }}
                                                        value={row.factor || ''}
                                                        placeholder='Enter supplier-specific factor'
                                                        onChange={(event) => { handleChange(event, row.id) }} />
                                                </TableCell>
                                                <TableCell align='left'>{row.uom}</TableCell>
                                                <TableCell align='left'>
                                                    <TextField
                                                        name={'source'}
                                                        sx={{
                                                            width: '100%', '& input::placeholder': {
                                                                fontStyle: 'italic'
                                                            }
                                                        }}
                                                        value={row.source || ''}
                                                        placeholder='Define supplier-specific source'
                                                        onChange={(event) => { handleChange(event, row.id) }} />
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {
                            formState?.length > 0 &&
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                    {
                                        formError &&
                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                            <Alert severity='error' sx={{ width: 'fit-content' }}>{formError}</Alert>
                                        </Box>
                                    }
                                    <Button
                                        variant='contained'
                                        sx={{ width: 'fit-content' }}
                                        onClick={onSubmit}
                                        disabled={isPosting}>
                                        {isPosting ? 'Submitting...' : 'Submit Emission Factors'}
                                    </Button>
                                </Box>
                                <Box sx={{ display: 'flex', alignSelf: 'start' }}>
                                    <TablePagination
                                        component="div"
                                        slotProps={{
                                            select: {
                                                sx: {
                                                    border: '1px solid rgba(224, 224, 224, 1)'
                                                }
                                            },
                                            actions: {
                                                sx: {
                                                    border: '1px solid rgba(224, 224, 224, 1)'
                                                }
                                            }
                                        }}
                                        count={totalRows}
                                        page={currentPage}
                                        onPageChange={handleChangePage}
                                        rowsPerPage={rowsPerPage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        labelDisplayedRows={(props) => {
                                            return (<LabelDisplayRows muiProps={props} rowsPerPage={rowsPerPage} />)
                                        }}
                                        showFirstButton
                                        showLastButton
                                    />
                                </Box>
                            </Box>
                        }
                        {
                            formState?.length === 0 && searchQuery === ''
                                ? <TableInfo variant={'No Data'} />
                                : formState?.length === 0 && searchQuery !== ''
                                    ? <TableInfo variant={'No Results'} />
                                    : null
                        }
                    </Box>
                </Box>
            }

        </Box>
    )
}

function TableInfo({ variant }) {
    const variantText = {
        'No Data': 'No Emission Factors info to display',
        'No Results': 'No Emission Factors matching search query found.'
    }
    return (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <Alert severity='info' sx={{ width: 'fit-content' }}>{variantText[variant]}</Alert>
        </Box>
    )
}

function LabelDisplayRows({ muiProps, rowsPerPage }) {
    const { from, to, count, page } = muiProps
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', fontSize: 17, gap: '1px' }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: 150 }}>
                Factors {from}-{to} of {count}
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: 150 }}>
                Page {page + 1} of {Math.ceil(count / rowsPerPage)}
            </Box>
        </Box>
    )
}
